import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { ReactComponent as CheckIcon } from 'static/svg/green-check.svg'

import FirstEnterprisePlanImg from 'static/images/first-enterprise-plan.png'
import CorporateScheduleImg from 'static/images/corporate-schedule.png'
import SecondEnterprisePlanImg from 'static/images/second-enterprise-plan.png'

import * as S from '../styles'

interface CorporateSuccessModalProps {
  onClose: () => void
  isPatientFirstPlan?: boolean
}

const CorporateSuccessModal = ({
  onClose,
  isPatientFirstPlan = false
}: CorporateSuccessModalProps): JSX.Element => {
  return (
    <ModalGeneric
      modalTitle={null}
      onCloseModal={onClose}
      btnText='VER MEUS CONVÊNIOS'
      btnOnClick={onClose}
      hasButton
    >
      <S.Container>
        <CheckIcon />
        <Typography variant='header4' weight='bold' customClassName='LinkPlanModalSuccess__SuccessTitle'>
          Convênio vinculado! <br />
          Veja os próximos passos:
        </Typography>
        
        <S.Content>
          <S.Step showBorder>
            <S.StepImage 
              src={isPatientFirstPlan ? FirstEnterprisePlanImg : SecondEnterprisePlanImg}
            />
            <S.StepContent>
              <S.StepCount>
                1
              </S.StepCount>
              {isPatientFirstPlan ? (
                <Typography variant='content2'>
                  Visualize seu convênio na sua página <br /> 
                  inicial, no painel de convênios. Ou acesse <br /> 
                  a área <b>“meus convênios”</b> pelo menu.
                </Typography>
              ) : (
                <Typography variant='content2'>
                  Visualize o novo convênio na sua página <br /> 
                  inicial, acessando o botão <b>“trocar”</b> no <br /> 
                  painel de convênios. Ou acesse a área <br /> 
                  <b>“meus convênios”</b> pelo menu.
                </Typography>
              )}
            </S.StepContent>
          </S.Step>
          <S.Step
            style={{
              paddingBottom: 15
            }}
          >
            <S.StepImage 
              src={CorporateScheduleImg}
            />
            <S.StepContent>
              <S.StepCount>
                2
              </S.StepCount>
              <Typography variant='content2'>
                Agora é só acessar o botão <b>“marcar consulta”</b> e prosseguir com o agendamento pelo convênio.
              </Typography>
            </S.StepContent>
          </S.Step>
        </S.Content>
      </S.Container>
    </ModalGeneric>
  )
}

export default CorporateSuccessModal